"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledHover = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const StyledHover = styled_components_1.default.span `
  cursor: ${({ pointer }) => (pointer ? 'pointer' : '')};
  color: ${({ defaultColor }) => (defaultColor ? defaultColor : '')};

  &:hover {
    color: ${({ hoverColor }) => (hoverColor ? hoverColor : 'inherit')};
  }
`;
exports.StyledHover = StyledHover;
